var PersistenceHistory = window.PersistenceHistory;
var PersistenceHistory;
window.Academia.Model = Backbone.Model.extend({
  initialize: function (options) {
    Backbone.Model.prototype.initialize.apply(this, arguments);
    this._history = new PersistenceHistory(this.attributes);
    return this.on("sync", function (_this) {
      return function () {
        return _this._history.record(_this.attributes);
      };
    }(this));
  },
  changes_since_last_sync: function () {
    return this._history.changes(this.attributes);
  },
  fetch: function (options) {
    var success;
    if (options == null) {
      options = {};
    }
    success = options.success;
    options.success = function (_this) {
      return function (resp, status, xhr) {
        if (success) {
          success(resp, status, xhr);
        }
        return _this._history.record(_this.attributes);
      };
    }(this);
    return Backbone.Model.prototype.fetch.apply(this, arguments);
  },
  parse: function (response) {
    if (this.propertyNames && this.propertyNames.length > 0) {
      _.each(this.propertyNames, function (_this) {
        return function (name) {
          return _this[name] = response[name];
        };
      }(this));
    }
    if (response[this.modelName] != null) {
      return response[this.modelName];
    } else {
      return response;
    }
  },
  revert: function () {
    var new_keys;
    new_keys = this._history.new_keys(this.attributes);
    _.each(new_keys, function (_this) {
      return function (key) {
        return _this.unset(key);
      };
    }(this));
    return this.set(this._history.last());
  },
  sync: function (method, model, options) {
    if (method === 'read') {
      options.dataType = 'jsonp';
    }
    options.url = model.url(method);
    if (method === 'create' || method === 'update') {
      options.contentType = 'application/json';
      options.data = JSON.stringify(function () {
        var obj;
        obj = {};
        obj[model.modelName] = model.toJSON();
        if (options.params) {
          _.extend(obj, options.params);
        }
        return obj;
      }());
    }
    return Backbone.sync(method, model, options);
  },
  url: function (method) {
    var args, components, key, relative, routeFun;
    if (this.routeKey == null) {
      throw "You need to define a routeKey from routes.js";
    }
    key = this.routeKey;
    relative = true;
    args = {};
    if (method !== 'create' && this.id != null) {
      args['id'] = this.id;
    }
    switch (method) {
      case 'create':
        key += 's';
        break;
      case 'read':
        relative = false;
        break;
      case 'update':
      case 'delete':
        'no change';
    }
    if (relative) {
      args['subdomain_param'] = 'api';
    }
    routeFun = $r[key + (relative ? '_path' : '_url')];
    components = $.extend(args, (typeof this.urlArgs === "function" ? this.urlArgs() : void 0) || {});
    return routeFun(components);
  }
});
PersistenceHistory = function () {
  function PersistenceHistory(first_state) {
    this.states = [];
    if (first_state != null) {
      this.record(first_state);
    }
  }
  PersistenceHistory.prototype.last = function () {
    return _.last(this.states);
  };
  PersistenceHistory.prototype.record = function (state) {
    return this.states.push($x.clone(state));
  };
  PersistenceHistory.prototype.changes = function (dirty_state) {
    var diff, last;
    diff = {};
    last = this.last();
    _.each(this.new_keys(dirty_state), function (key) {
      return diff[key] = dirty_state[key];
    });
    _.each(_.keys(last), function (key) {
      var new_value, old_value;
      old_value = last[key];
      new_value = dirty_state[key];
      if (old_value !== new_value) {
        return diff[key] = new_value;
      }
    });
    return diff;
  };
  PersistenceHistory.prototype.new_keys = function (dirty_state) {
    return _.difference(_.keys(dirty_state), _.keys(this.last()));
  };
  return PersistenceHistory;
}();
window.PersistenceHistory = PersistenceHistory;